<template>
  <div>
    <div class="text-center" v-if="pages > 1">
      <v-pagination v-model="page" :length="pages"></v-pagination>
    </div>
    <div class="d-flex flex-row mb-6 align-self-center d-flex justify-center flex-wrap pa-2">
      <v-btn
        :disabled="!selectedIcon"
        color="error"
        @click="deleteHandler(selectedIcon)"
      >{{ $t("globals.delete") }}</v-btn>
    </div>
    <div class="d-flex flex-row mb-6 align-self-center flex-wrap">
      <div v-for="icon of icons" v-bind:key="icon.Id">
        <div
          tabindex="0"
          :class="[
            selectedIcon && selectedIcon.Id == icon.Id ? 'primary' : '',
            'icon',
          ]"
          @focus="$emit('update:selectedIcon', icon)"
        >
          <div class="icon-wrapper" v-html="icon.Svg"></div>
        </div>
      </div>
    </div>
    <div class="no-items" v-if="icons.length == 0">{{ $t("globals.no_items") }}</div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import IconUploader from "../components/IconUploader";
export default {
  name: "icon-list",
  components: {
    IconUploader
  },
  props: {
    selectedIcon: Object
  },
  data: () => ({
    icons: [],
    page: 1,
    pages: 0
  }),
  watch: {
    page: {
      immediate: true,
      async handler() {
        this.icons = [];
        await this.loadIcons();
      }
    }
  },
  mounted() {},
  destroyed() {
    this.icons = [];
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" })
  },
  methods: {
    ...mapActions("downloadCenter", ["getIcons", "deleteIcon"]),
    async loadIcons() {
      const res = await this.getIcons({
        planId: this.selectedPlan.Id,
        page: this.page
      });
      this.pages = Math.ceil(res["@odata.count"] / 30);
      this.icons = res.value;
    },

    async deleteHandler(item) {
      await this.deleteIcon(item);
      this.$emit("update:selectedIcon", undefined);
      await this.loadIcons();
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    async blur() {
      this.$emit("update:selectedIcon", null);
    }
  }
};
</script>
<style scoped>
.icon {
  margin: 1px;
  border: 6px solid white;
}
.icon-wrapper {
  background: white;
  padding: 3px;
  width: 60px;
  height: 60px;
}
.no-items {
  text-align: center;
  padding: 20px;
}
</style>
